import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface TrackPageViewProps {
  clientId?: string;
}

export function TrackPageView({ clientId }: TrackPageViewProps) {
  const { pathname } = useLocation();
  const GA_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;

  useEffect(() => {
    if (!window.gtag || !GA_ID) return;

    const config: Record<string, unknown> = {
      page_path: pathname,
    };

    // Add clientId to the configuration if available
    if (clientId) {
      config.tenant_id = clientId;
    }

    window.gtag('config', GA_ID, config);
  }, [pathname, clientId, GA_ID]);

  return null;
}
